import { FC, memo, useMemo, useState } from 'react';
import Box from '@material-ui/core/Box';
import clip from 'text-clipper';
import styled from 'styled-components';

import { Description, Title, MoreDetailsButton } from './overview.styles';
import { OverviewProps } from './overview.types';

const CLIP_MAX_LENGTH = 650;

const S = {
  decriptiveContent: styled.div`
    a {
      text-decoration: revert-layer;
      text-decoration-style: dotted !important;
      text-underline-position: under;
    }
  `,
};

export const Overview: FC<OverviewProps> = memo(
  ({ title = null, description, className }) => {
    const [text, setText] = useState<string>(
      clip(description, CLIP_MAX_LENGTH, { html: true })
    );
    const isVisibleButton = useMemo(() => text.length !== description.length, [
      text,
      description,
    ]);

    const handleButtonClick = () => {
      setText(description);
    };

    return (
      <Box className={className}>
        <Title variant="h2">{title ?? 'Overview'}</Title>
        <S.decriptiveContent>
          <Description dangerouslySetInnerHTML={{ __html: text }} />
        </S.decriptiveContent>
        {isVisibleButton && (
          <MoreDetailsButton onClick={handleButtonClick}>
            More details
          </MoreDetailsButton>
        )}
      </Box>
    );
  }
);
